import NewUom from './NewUom'

export default NewUom



// WEBPACK FOOTER //
// ./src/components/Uoms/New/index.js